import { cn } from '@src/lib/utils';

import { ProcessFieldTextField } from './ProcessFieldTextField';

import { useTranslation } from 'react-i18next';

export function ProcessFieldTextFieldAiChat({
    className,
    fieldProps,
    placeholder,
    ...props
}: React.ComponentProps<typeof ProcessFieldTextField>) {
    const { t } = useTranslation();

    return (
        <ProcessFieldTextField
            {...props}
            placeholder={placeholder ?? t('translation:enterAnswer')}
            className={cn(
                'mb-0! w-full gap-0! [&>label]:mb-0! [&>label]:w-full! [&>label]:border-b [&>label]:border-solid [&>label]:border-(--color-card-text)/10 [&>label]:px-[18px] [&>label]:py-4 [&>label]:text-sm! [&>label]:leading-5! [&>label]:font-medium! [&>.serviceFormMessage]:mx-[18px] [&>.serviceFormMessage]:mb-3',
                '[&>textarea]:mx-[18px] [&>textarea]:my-3 [&>textarea]:w-[calc(100%-36px)]!',
                '[&>textarea:focus-visible]:outline-2! [&>textarea:focus-visible]:outline-solid! [&>textarea:focus-visible]:outline-(--color-brand-green)! [&>textarea[data-error=true]]:outline-1! [&>textarea[data-error=true]]:outline-solid! [&>textarea[data-error=true]]:outline-(--color-danger)!',
                '[&>.quill]:mx-[18px] [&>.quill]:my-3 [&>.quill]:w-[calc(100%-36px)]!',
                className,
            )}
            fieldProps={{
                ...fieldProps,
                className: cn(
                    'rounded-xl! border-0! bg-(--color-ai-file-upload-bg)! px-4! py-2! text-sm! leading-5! font-medium! text-(--color-card-text)! placeholder:text-(--color-neutral-6)!',
                    'h-[102px]! min-h-[102px]! resize-none overflow-y-auto',
                    fieldProps?.className,
                ),
            }}
        />
    );
}
